import { createReducer } from 'reducers';
import { Map, List } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REQUESTED,
    SUCCESSFUL,
    FAILED,
    GET_ALL_POSTING_REQUESTED,
    GET_ALL_POSTING_FAILED,
    GET_ALL_POSTING_SUCCESSFUL,
    UPDATE_REQUESTED,
    UPDATE_FAILED,
    UPDATE_SUCCESSFUL,
    DELETE_POSTING_REQUESTED,
    DELETE_POSTING_SUCCESSFUL,
    DELETE_POSTING_FAILED,
   ALL_POSTINGS_CREATED_SUCCESSFUL,
    CREATE_POSTINGS_REQUESTED,
} from './actionTypes';

export const initialState = Map({
  postings: Map(),
  error: Map(),
  requested: false,
  isLoading: false,
  allPostings: List(),
  postingAdded: false,
  postingGettingAdded: false,
  editPostingRequested: false,
  currentPosting: Map(),
  editedPosting: Map(),
  postingGettingDeleted: false,
  postingDeleted: false,
  requestPostings: false,
});

const handlers = {
  [REQUESTED](state) {
    return state.merge({
      requested: true,
      error: Map(),
      isLoading: true,
      postingGettingAdded: true,
    });
  },
  [FAILED](state, action) {
    return state.merge({
      requested: false,
      error: action.error,
    });
  },
  [SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      allPostings: state.get('allPostings').push(action.postings),
      error: Map(),
      isLoading: false,
      postingAdded: true,
      postingGettingAdded: false,
    });
  },
  [GET_ALL_POSTING_REQUESTED](state) {
    return state.merge({
      requested: true,
      isLoading: true,
      postingGettingAdded: true,
      postingAdded: false,
    });
  },
  [GET_ALL_POSTING_FAILED](state, action) {
    return state.merge({
      requested: false,
      error: action.err,
      isLoading: false,
    });
  },
  [GET_ALL_POSTING_SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      allPostings: action.data,
      isLoading: false,
      requestPostings: false,
      postingAdded: false,
      postingGettingAdded: false,
    });
  },
  [UPDATE_REQUESTED](state) {
    return state.merge({
      isLoading: true,
      editPostingRequested: true,
    });
  },
  [UPDATE_SUCCESSFUL](state, action) {
    const updatedPostings = action.data.get('Attributes');
    return state.merge({
      allPostings: state.get('allPostings').set(action.index, updatedPostings),
      postingAdded: true,
      editPostingRequested: false,
    });
  },
  [UPDATE_FAILED](state, action) {
    return state.merge({
      err: action.error,
    });
  },
  [DELETE_POSTING_REQUESTED](state) {
    return state.merge({
      postingGettingDeleted: true,
    });
  },
  [DELETE_POSTING_SUCCESSFUL](state, action) {
    const id = action.transaction.get('id');
    const index = state.get('allPostings').findIndex(posting => posting.get('id') === id);
    const list = state.get('allPostings').delete(index);

    return state.merge({
      postingGettingDeleted: false,
      postingDeleted: true,
      allPostings: list,
    });
  },
  [DELETE_POSTING_FAILED](state) {
    return state.merge({
      postingGettingDeleted: false,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      postings: Map(),
      error: Map(),
      requested: false,
      isLoading: false,
      allPostings: List(),
      postingAdded: false,
      postingGettingAdded: false,
      editPostingRequested: false,
      currentPosting: Map(),
      editedPosting: Map(),
      postingGettingDeleted: false,
      postingDeleted: false,
    });
  },
  [ALL_POSTINGS_CREATED_SUCCESSFUL](state, action) {
    return state.merge({
      allPostings: action.postings,
      postingGettingAdded: false,
    });
  },
  [CREATE_POSTINGS_REQUESTED](state) {
    return state.merge({
      postingGettingAdded: true,
    });
  },
};

export const postingsStore = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.postingsStore.get('error');
const getPostings = state => state.postingsStore.get('postings');
const IsRequested = state => state.postingsStore.get('requested');
const getAllPostings = state => state.postingsStore.get('allPostings');
const getpostingAdded = state => state.postingsStore.get('postingAdded');
const getPostingGettingAdded = state => state.postingsStore.get('postingGettingAdded');
const getEditPostingRequested = state => state.postingsStore.get('editPostingRequested');
const getCurrentPosting = state => state.postingsStore.get('currentPosting');
const getEditedPosting = state => state.postingsStore.get('editedPosting');
const getPostingGettingDeleted = state => state.postingsStore.get('postingGettingDeleted');
const getPostingDeleted = state => state.postingsStore.get('postingDeleted');

export const postings = createStructuredSelector({
  error: getError,
  postings: getPostings,
  requested: IsRequested,
  allPostings: getAllPostings,
  postingAdded: getpostingAdded,
  postingGettingAdded: getPostingGettingAdded,
  editPostingRequested: getEditPostingRequested,
  currentPosting: getCurrentPosting,
  editedPosting: getEditedPosting,
  postingGettingDeleted: getPostingGettingDeleted,
  postingDeleted: getPostingDeleted,
});



// WEBPACK FOOTER //
// ./src/components/Postings/redux.js